export const messages = {
  en: {
    allocationStorehouseEnter: {
      title: 'Allocation Warehouse Entry',
      applyId: 'Apply ID: ',
      resourceType: 'Resource Type',
      resourceName: 'Resource Name',
      specification: 'Specification',
      resourceCode: 'Resource Code',
      fixedResource: 'Fixed Resource',
      transferredWarehouse: 'Transferred Warehouse',
      returnPerson: 'Return Person',
      originalWarehouse: 'Original Warehouse',
      targetWarehouse: 'Target Warehouse',
      originalStock: 'Original Stock',
      transferQuantity: 'Transfer Quantity',
      actualQuantity: 'Actual Quantity',
      quantityPlaceholder: 'Required, please enter the transfer quantity',
      submit: 'Submit',
      fetchError: 'Failed to fetch allocation data',
      selectItemsWarning: 'Please select items to transfer',
      quantityWarning: 'Please enter valid quantity for all selected items',
      submitSuccess: 'Operation successful',
      submitError: 'Operation failed'
    }
  },
  zh: {
    allocationStorehouseEnter: {
      title: '调拨入库',
      applyId: '单号：',
      resourceType: '物品类型',
      resourceName: '物品名称',
      specification: '物品规格',
      resourceCode: '物品编码',
      fixedResource: '固定物品',
      transferredWarehouse: '被调仓库',
      returnPerson: '退还人',
      originalWarehouse: '原仓库',
      targetWarehouse: '目标仓库',
      originalStock: '原库存',
      transferQuantity: '调拨数量',
      actualQuantity: '实际数量',
      quantityPlaceholder: '必填，请填写调拨数量',
      submit: '提交',
      fetchError: '获取调拨数据失败',
      selectItemsWarning: '请选择调拨物品',
      quantityWarning: '请为所有选中物品填写有效数量',
      submitSuccess: '操作成功',
submitError: '操作失败'
    }
  },
  'zh-TW': {
    allocationStorehouseEnter: {
      title: '調撥入庫',
      applyId: '單號：',
      resourceType: '物品類型',
      resourceName: '物品名稱',
      specification: '物品規格',
      resourceCode: '物品編碼',
      fixedResource: '固定物品',
      transferredWarehouse: '被調倉庫',
      returnPerson: '退還人',
      originalWarehouse: '原倉庫',
      targetWarehouse: '目標倉庫',
      originalStock: '原庫存',
      transferQuantity: '調撥數量',
      actualQuantity: '實際數量',
      quantityPlaceholder: '必填，請填寫調撥數量',
      submit: '提交',
      fetchError: '獲取調撥數據失敗',
      selectItemsWarning: '請選擇調撥物品',
      quantityWarning: '請為所有選中物品填寫有效數量',
      submitSuccess: '操作成功',
      submitError: '操作失敗'
    }
  }
}